function updateVisibleSlideTabbing() {
    const sliders = document.querySelectorAll('.collection-item-slider');
  
    sliders.forEach(slider => {
        const sliderRect = slider.getBoundingClientRect();
        const slides = slider.querySelectorAll('.swiper-slide');

        slides.forEach(slide => {
        const rect = slide.getBoundingClientRect();
        const isVisible =
            rect.width > 0 &&
            rect.height > 0 &&
            rect.left >= sliderRect.left &&
            rect.right <= sliderRect.right;

            slide.querySelectorAll('a, button, input, textarea, select, [tabindex]').forEach(el => {
                el.tabIndex = isVisible ? 0 : -1;
            });
        });
    });
}

function updateStickyType() {
    const viewportHeight = window.innerHeight;
  
    if (viewportHeight < 375) {
        const header = document.querySelector('.header');
        header.setAttribute('data-sticky-type', 'on-scroll-up');
    }
}

function accordionSetup() {
    const accordions = document.querySelectorAll('.accordion-details.footer-accordion-details');

    accordions.forEach(details => {
        const button = details.querySelector('.accordion-details__summary');
        const content = details.querySelector('.accordion-details__content');

        if (window.innerWidth < 1024) {
            content.style.opacity = '0';
            content.style.transform = 'translateY(0px)';
            content.classList.add('hidden');
            button.setAttribute('aria-expanded', 'false');
            button.removeAttribute('disabled');
        } else {
            content.style.opacity = '1';
            content.style.transform = 'translateY(0px)';
            content.classList.remove('hidden');
            button.setAttribute('aria-expanded', 'true');
            button.disabled = true;
        }

        // Toggle visibility on click
        button.addEventListener('click', () => {
            if (content.classList.contains('hidden')){
                content.style.opacity = '1';
                content.classList.remove('hidden');
                button.setAttribute('aria-expanded', 'true');
            } else {
                content.style.opacity = '0';
                content.classList.add('hidden');
                button.setAttribute('aria-expanded', 'false');
            }
        });
    });

    const updateVisibility = () => {
        accordions.forEach(details => {
            const content = details.querySelector('.accordion-details__content');
            const button = details.querySelector('.accordion-details__summary');

            if (window.innerWidth < 1024) {
                content.classList.add('hidden');
                button.setAttribute('aria-expanded', 'false');
                content.style.opacity = '0';
                button.removeAttribute('disabled');
            } else {
                content.classList.remove('hidden');
                content.style.opacity = '1';
                button.setAttribute('aria-expanded', 'true');
                button.disabled = true;
            }
        });
    };

    const mediaQuery = window.matchMedia('(min-width: 1024px)');
    mediaQuery.addEventListener('change', () => {
        updateVisibility();
    });
}

window.addEventListener('load', function () {
    updateVisibleSlideTabbing();
    updateStickyType();
    accordionSetup();
});
  
document.addEventListener('click', () => {
    setTimeout(updateVisibleSlideTabbing, 50);
});
  
document.addEventListener('keydown', (e) => {
    if (['ArrowLeft', 'ArrowRight'].includes(e.key)) {
        setTimeout(updateVisibleSlideTabbing, 50);
    }
});
  
document.querySelectorAll('.collection-item-slider').forEach(slider => {
    const observer = new MutationObserver(updateVisibleSlideTabbing);
  
    observer.observe(slider, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'style'],
    });
});
  
customElements.whenDefined('collection-item-slider').then(() => {
    const sliders = document.querySelectorAll('collection-item-slider');
  
    sliders.forEach(slider => {
        const sliderRect = slider.getBoundingClientRect();
        const focusableElements = slider.querySelectorAll('a, button, input, textarea, select, [tabindex]');
  
        focusableElements.forEach(element => {
            element.addEventListener('focusin', (event) => {
                const slide = element.closest('.swiper-slide');
                if (!slide) return;
  
                const rect = slide.getBoundingClientRect();
                const isVisible =
                    rect.width > 0 &&
                    rect.height > 0 &&
                    rect.left >= sliderRect.left &&
                    rect.right <= sliderRect.right;
    
                if (!isVisible) {
                    event.preventDefault();
                    element.blur();
                }
            });
        });
    });
});
  
document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {
      const quickviewBtn = e.target.closest('.product-card__quickview');
      if (!quickviewBtn) return;

      setTimeout(() => {
        document.querySelectorAll('.quantity').forEach(selector => {

          const input = selector.querySelector('.quantity__input');
          const liveRegion = selector.querySelector('[aria-live]');
          const minusBtn = selector.querySelector('button[name="minus"]');
          const plusBtn = selector.querySelector('button[name="plus"]');

          function updateLiveRegion() {
            if (liveRegion) {
              const value = input.value;
              liveRegion.textContent = `Quantity updated to ${value}`;
            }
          }

          if (minusBtn) minusBtn.addEventListener('click', updateLiveRegion);
          if (plusBtn) plusBtn.addEventListener('click', updateLiveRegion);
          input.addEventListener('input', updateLiveRegion);
          input.addEventListener('change', updateLiveRegion);
        });
      }, 500);
    });
  });